import type { TeactNode } from '../lib/teact/teact';
import { useState } from '../lib/teact/teact';

import useLang from '../hooks/useLang';

import Button from '../components/ui/Button';
import Checkbox from '../components/ui/Checkbox';

import styles from './CrmAuthDisclosure.module.scss';

type OwnProps = {
  children: TeactNode;
};

// Consent lasts only for this mounted login flow, including QR, phone, code and password screens
const CrmAuthDisclosure = ({ children }: OwnProps) => {
  const lang = useLang();
  const [hasAcknowledged, setHasAcknowledged] = useState(false);
  const [hasContinued, setHasContinued] = useState(false);

  function handleContinue() {
    if (hasAcknowledged) setHasContinued(true);
  }

  return (
    <div className={styles.root}>
      <section className={hasContinued ? styles.banner : styles.intro} aria-label={lang('LachesisCrmTitle')}>
        <img className={styles.logo} src="./lachesis-icon.svg" alt="" />
        <h1 className={styles.title}>{lang('LachesisCrmTitle')}</h1>
        <p className={styles.identity}>{lang('LachesisCrmIdentity')}</p>
        {!hasContinued && (
          <>
            <p className={styles.description}>{lang('LachesisCrmPurpose')}</p>
            <p className={styles.description}>{lang('LachesisCrmData')}</p>
            <p className={styles.description}>{lang('LachesisCrmSession')}</p>
          </>
        )}
        <div className={styles.links}>
          <a href="./about-crm.html" target="_blank" rel="noopener noreferrer">
            {lang('LachesisCrmDetails')}
          </a>
          <a href="https://web.telegram.org/a/" target="_blank" rel="noopener noreferrer">
            {lang('LachesisCrmOfficial')}
          </a>
        </div>
        {!hasContinued && (
          <div className={styles.consent}>
            <Checkbox
              label={lang('LachesisCrmConsent')}
              checked={hasAcknowledged}
              onCheck={setHasAcknowledged}
            />
            <Button disabled={!hasAcknowledged} onClick={handleContinue}>
              {lang('LachesisCrmContinue')}
            </Button>
          </div>
        )}
      </section>
      {hasContinued && <div className={styles.auth}>{children}</div>}
    </div>
  );
};

export default CrmAuthDisclosure;
